import React from "react";
import ChartInDialogButton from "components/basic/chart-in-dialog-button/ChartInDialogButton";
import { Instant } from "@js-joda/core";

export enum TableTypes {
  DEFAULT = "default",
  GROUPED = "grouped",
  TRANSPOSED = "transposed",
}

interface DatasetChartButtonWrapperProps {
  identifier: string;
  currentIdentifiers: string[];
  setCurrentIdentifiers: (currentIdentifiers: string[]) => void;
  tableType: TableTypes;
  dateFrom?: Instant;
  dateTo?: Instant;
}

const DatasetChartButtonWrapper: React.FC<DatasetChartButtonWrapperProps> = ({
  identifier,
  currentIdentifiers,
  setCurrentIdentifiers,
  tableType,
  dateFrom,
  dateTo,
}) => {
  const isSelected = currentIdentifiers.includes(identifier);
  const handleSelect = (e: React.MouseEvent) => {
    if (e.ctrlKey) {
      if (isSelected) {
        setCurrentIdentifiers(currentIdentifiers.filter(id => id !== identifier));
      } else {
        setCurrentIdentifiers([...currentIdentifiers, identifier]);
      }
    }
  };

  let identifiers;

  if (tableType === TableTypes.DEFAULT) {
    identifiers = currentIdentifiers.includes(identifier) ? currentIdentifiers : undefined;
  } else {
    identifiers = isSelected ? currentIdentifiers : undefined;
  }
  return (
    <div className={`non-printable ${isSelected ? "text-yellow-500" : ""}`} onClick={handleSelect}>
      <ChartInDialogButton identifier={identifier} identifiers={identifiers} dateFrom={dateFrom} dateTo={dateTo} />
    </div>
  );
};

export default DatasetChartButtonWrapper;
